import { Component, OnInit } from "@angular/core";
import { ReportPageBase } from "../components/report-page-base";
import { ReportsService } from "../../shared/services/reports.service";
import { NotificationService } from "../../core/services/notification.service";
import { AppService } from "../../app.service";
import { NotificationType } from "../../core/services/notification-type";
import { saveAs } from 'file-saver';

@Component({
    selector: 'reclamation-requests-report-page',
    templateUrl: './reclamation-requests-report.page.html',
    styleUrls: [
        './reclamation-requests-report.page.scss',
        '../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
    ]
})
export class ReclamationRequestsReportPage extends ReportPageBase implements OnInit {

    constructor(
        private reportsService: ReportsService,
        private notificationService: NotificationService,
        private appService: AppService
    ) {
        super();
        appService.pageTitle = 'Отчет. Рекламация'
    }

    dataGeneratingReclamationMonthly: boolean = false;
    public range = { start: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), end: new Date(new Date().getFullYear(), new Date().getMonth(), 0) };
    rangeReclamationMonthly = { start: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), end: new Date(new Date().getFullYear(), new Date().getMonth(), 0) };
    rangeReclamationMonthlyEmps = { start: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), end: new Date(new Date().getFullYear(), new Date().getMonth(), 0) };
    dataGeneratingReclamationMonthlyEmps: boolean = false;
    rangeReclamationDailyEmps = { start: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), end: new Date(new Date().getFullYear(), new Date().getMonth(), 0) };
    dataGeneratingReclamationDailyEmps: boolean = false;
    
    generateReport() {
        this.generateReportByDateRange((startDate, endDate) => {
            this.reportsService.getReclamationRequests(startDate, endDate)
                .subscribe(blob => {
                    if (blob.type === 'application/octet-stream') {
                        let nowDate = new Date();
                        saveAs(blob, `Отчет_по_обращениям_в_отдел_рекламаций_${nowDate.toLocaleDateString()}_${nowDate.getHours()}_${nowDate.getMinutes()}_${nowDate.getSeconds()}.xlsx`);
                        this.dataGenerating = false;
                    } else if (blob.type === 'application/json') {
                        blob
                            .text()
                            .then(result => {
                                const response = JSON.parse(result);
                                if (!response.isSuccessful) {
                                    this.notificationService.error({
                                        title: 'Ошибка',
                                        message: response.errorDescription as string,
                                        notificationType: NotificationType.SweetAlert
                                    });
                                }

                                this.dataGenerating = false;
                            });
                    }
                });

        });
    }

    generateReportReclamationMonthly() {
        this.dataGeneratingReclamationMonthly = true;
        this.generateReportByDateRange((startDate, endDate) => {
            this.reportsService.getReclamationMonthly(startDate, endDate)
                .subscribe(blob => {
                    if (blob.type === 'application/octet-stream') {
                        let nowDate = new Date();
                        saveAs(blob, `Ежемесячный_отчет_по_рекламациям_${nowDate.toLocaleDateString()}_${nowDate.getHours()}_${nowDate.getMinutes()}_${nowDate.getSeconds()}.xlsx`);
                        this.dataGeneratingReclamationMonthly = false;
                    } else if (blob.type === 'application/json') {
                        blob
                            .text()
                            .then(result => {
                                const response = JSON.parse(result);
                                if (!response.isSuccessful) {
                                    this.notificationService.error({
                                        title: 'Ошибка',
                                        message: response.errorDescription as string,
                                        notificationType: NotificationType.SweetAlert
                                    });
                                }

                                this.dataGeneratingReclamationMonthly = false;
                            });
                    }
                });

        }, this.rangeReclamationMonthly, false);
    }

    generateReportReclamationMonthlyEmps() {
        this.dataGeneratingReclamationMonthlyEmps = true;
        this.generateReportByDateRange((startDate, endDate) => {
            this.reportsService.getReclamationMonthlyEmps(startDate, endDate)
                .subscribe(blob => {
                    if (blob.type === 'application/octet-stream') {
                        let nowDate = new Date();
                        saveAs(blob, `Ежемесячный_отчет_по_сотрудникам_отдела_рекламаций_${nowDate.toLocaleDateString()}_${nowDate.getHours()}_${nowDate.getMinutes()}_${nowDate.getSeconds()}.xlsx`);
                        this.dataGeneratingReclamationMonthlyEmps = false;
                    } else if (blob.type === 'application/json') {
                        blob
                            .text()
                            .then(result => {
                                const response = JSON.parse(result);
                                if (!response.isSuccessful) {
                                    this.notificationService.error({
                                        title: 'Ошибка',
                                        message: response.errorDescription as string,
                                        notificationType: NotificationType.SweetAlert
                                    });
                                }

                                this.dataGeneratingReclamationMonthlyEmps = false;
                            });
                    }
                });

        }, this.rangeReclamationMonthlyEmps, false);
    }

    generateReportReclamationDailyEmps() {
        this.dataGeneratingReclamationDailyEmps = true;
        this.generateReportByDateRange((startDate, endDate) => {
            this.reportsService.getReclamationDailyEmps(startDate, endDate)
                .subscribe(blob => {
                    if (blob.type === 'application/octet-stream') {
                        let nowDate = new Date();
                        saveAs(blob, `Ежедневный_отчет_по_сотрудникам_отдела_рекламаций_${nowDate.toLocaleDateString()}_${nowDate.getHours()}_${nowDate.getMinutes()}_${nowDate.getSeconds()}.xlsx`);
                        this.dataGeneratingReclamationDailyEmps = false;
                    } else if (blob.type === 'application/json') {
                        blob
                            .text()
                            .then(result => {
                                const response = JSON.parse(result);
                                if (!response.isSuccessful) {
                                    this.notificationService.error({
                                        title: 'Ошибка',
                                        message: response.errorDescription as string,
                                        notificationType: NotificationType.SweetAlert
                                    });
                                }

                                this.dataGeneratingReclamationDailyEmps = false;
                            });
                    }
                });

        }, this.rangeReclamationDailyEmps, false);
    }
}